import { useState } from "react";
import IconButton from "./IconButton";
import IconAdd from "../../icons/IconAdd";
import IconStop from "../../icons/IconStop";
import IconRefresh from "../../icons/IconRefresh";

export function Labeled({ label, children }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem" }}>
      {children}
      <span style={{ fontSize: "0.75rem", color: "#616161" }}>{label}</span>
    </div>
  );
}

## Interactive Example

export function InteractiveIconButton() {
  const [style, setStyle] = useState("secondary");
  const [size, setSize] = useState("medium");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "24rem" }}>
      <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
        <select value={style} onChange={(e) => setStyle(e.target.value)}>
          <option value="primary">Primary</option>
          <option value="secondary">Secondary</option>
          <option value="tertiary">Tertiary</option>
          <option value="black">Black</option>
        </select>
        <select value={size} onChange={(e) => setSize(e.target.value)}>
          <option value="jumbo">Jumbo</option>
          <option value="large">Large</option>
          <option value="medium">Medium</option>
          <option value="small">Small</option>
          <option value="xsmall">XSmall</option>
        </select>
      </div>
      <IconButton btnStyle={style} btnSize={size} ariaLabel="Add">
        <IconAdd />
      </IconButton>
    </div>
  );
}

<InteractiveIconButton />

---

## Styles

<div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", alignItems: "flex-start" }}>
  <Labeled label="primary">
    <IconButton btnStyle="primary" ariaLabel="Add"><IconAdd /></IconButton>
  </Labeled>
  <Labeled label="secondary">
    <IconButton btnStyle="secondary" ariaLabel="Add"><IconAdd /></IconButton>
  </Labeled>
  <Labeled label="tertiary">
    <IconButton btnStyle="tertiary" ariaLabel="Add"><IconAdd /></IconButton>
  </Labeled>
  <Labeled label="black">
    <IconButton btnStyle="black" ariaLabel="Add"><IconAdd /></IconButton>
  </Labeled>
</div>

---

## Sizes

<div style={{ display: "flex", alignItems: "flex-start", gap: "1rem" }}>
  <Labeled label="jumbo">
    <IconButton btnSize="jumbo" ariaLabel="Jumbo"><IconAdd /></IconButton>
  </Labeled>
  <Labeled label="large">
    <IconButton btnSize="large" ariaLabel="Large"><IconAdd /></IconButton>
  </Labeled>
  <Labeled label="medium">
    <IconButton btnSize="medium" ariaLabel="Medium"><IconAdd /></IconButton>
  </Labeled>
  <Labeled label="small">
    <IconButton btnSize="small" ariaLabel="Small"><IconAdd /></IconButton>
  </Labeled>
  <Labeled label="xsmall">
    <IconButton btnSize="xsmall" ariaLabel="XSmall"><IconAdd /></IconButton>
  </Labeled>
</div>

---

## States

<div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", alignItems: "flex-start" }}>
  <Labeled label="normal">
    <IconButton ariaLabel="Normal"><IconAdd /></IconButton>
  </Labeled>
  <Labeled label="pending">
    <IconButton ariaLabel="Pending" isPending><IconAdd /></IconButton>
  </Labeled>
  <Labeled label="disabled">
    <IconButton ariaLabel="Disabled" disabled><IconAdd /></IconButton>
  </Labeled>
</div>

---

## With Tooltip

<IconButton ariaLabel="Refresh data" tooltip="Refresh the latest data"><IconRefresh /></IconButton>

---

## In a toolbar

<div
  style={{
    display: "inline-flex",
    gap: "0.5rem",
    alignItems: "center",
    padding: "0.5rem",
    border: "1px solid #e5e5e5",
    borderRadius: "8px",
    background: "#fafafa",
  }}
>
  <IconButton btnStyle="tertiary" btnSize="small" ariaLabel="Refresh"><IconRefresh /></IconButton>
  <IconButton btnStyle="tertiary" btnSize="small" ariaLabel="Stop"><IconStop color="orange" /></IconButton>
  <IconButton btnStyle="primary" btnSize="small" ariaLabel="Add"><IconAdd /></IconButton>
</div>
